import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IReferralPoint {
    inviters: IReferralPointInviters[]
    points: number
    user_id: string
    user_name: string
}

export interface IReferralPointInviters {
    id: string
    name: string
    thumbnail: string
}

export const getReferralPoint = async (currentPage, pageSize): Promise<ApiRes<IReferralPoint[]>> => {
    return await apiGet(API_URL, `admin/point/referral/list?current_page=${currentPage}&page_size=${pageSize}`)
}
